export const sidebarReducer = (state = { name: 'Chats', channel: 'Ch1' }, action) => {
  switch (action.type) {
    case 'SIDEBAR':
      return action
    default:
      return state
  }
}
